<!-- My Data + Self-Service Container -->
<div class="profile-container">

  <!-- Page Header -->
  <div class="profile-header">
    <h1>{{'MyData' | translate}}</h1>
  </div>

  <!-- Self-Service Management -->
  <div class="profile-card self-service-card" *ngIf="this.B2BPartner?.ID">
    <div class="card-header">
      <i class="material-icons">settings</i>
      <h2>{{'SelfServiceManagement' | translate}}</h2>
    </div>

    <!-- Tabs -->
    <div class="self-service-tabs">
      <button class="self-service-tab" [class.active]="SelfServiceTab == 1" (click)="SelectSelfServiceTab(1);">
        <i class="material-icons">receipt_long</i>
        <span>{{'BillingInformation' | translate}}</span>
      </button>
      <button class="self-service-tab" [class.active]="SelfServiceTab == 2" (click)="SelectSelfServiceTab(2);">
        <i class="material-icons">local_shipping</i>
        <span>{{'ShippingAddresses' | translate}}</span>
      </button>
      <button class="self-service-tab" [class.active]="SelfServiceTab == 3" (click)="SelectSelfServiceTab(3);">
        <i class="material-icons">people</i>
        <span>{{'AgentsInfo' | translate}}</span>
      </button>
    </div>

    <div class="card-content">

      <!-- ========== TAB 1: BILLING ========== -->
      <div *ngIf="SelfServiceTab == 1">
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'Name' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.Name">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'VAT' | translate}}</label>
          <div class="ModernFormInputWithIcon">
            <input type="text" class="ModernFormInput readonly" [(ngModel)]="this.B2BPartner.VAT" readonly>
            <i class="material-icons input-icon readonly">lock</i>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'COCRegNumber' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.COCRegNumber">
        </div>

        <div class="subsection-header">
          <i class="material-icons">location_on</i>
          <span>{{'BillingInformation' | translate}}</span>
        </div>

        <!-- Country Dropdown -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'Country' | translate}}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showBillingCountryDropdown" (click)="showBillingCountryDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showBillingCountryDropdown = !showBillingCountryDropdown; LoadCountries();">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">flag</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.B2BPartner?.BillingAddress?.Country?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showBillingCountryDropdown" style="max-height: 200px;">
              <div class="SendEmailSearchResult" *ngFor="let c of Countries"
                   (click)="this.B2BPartner.BillingAddress.Country = c; showBillingCountryDropdown = false;">
                <div class="SendEmailResultMain">
                  <span class="SendEmailResultLabel">{{ c.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'StateProvince' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.BillingAddress.StateProvince">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'City' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.BillingAddress.City">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'AddressLine' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.BillingAddress.AddressLine">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'ZipCode' | translate}}</label>
          <input type="text" class="ModernFormInput" [(ngModel)]="this.B2BPartner.BillingAddress.ZipCode">
        </div>

        <button class="save-personal-info-button" (click)="SaveBillingInfo();">
          <i class="material-icons">save</i>
          <span>{{'SaveButton' | translate}}</span>
        </button>
      </div>

      <!-- ========== TAB 2: SHIPPING ========== -->
      <div *ngIf="SelfServiceTab == 2">
        <div class="self-service-list" *ngIf="this.B2BPartner?.ShippingAddresses?.length > 0 && !EditingShippingAddress && !ShowNewShippingAddressForm">
          <div class="self-service-list-item" *ngFor="let a of this.B2BPartner.ShippingAddresses" (click)="EditShippingAddress(a);">
            <div class="self-service-list-item-main">
              <i class="material-icons" style="color: #007aff;">location_on</i>
              <div class="self-service-list-item-text">
                <span class="self-service-list-item-title">{{ a.ContactCompany || a.ContactPerson }}</span>
                <span class="self-service-list-item-sub">{{ a.Country?.Name }} - {{ a.City }}, {{ a.AddressLine }} ({{ a.ZipCode }})</span>
              </div>
            </div>
            <i class="material-icons self-service-list-item-action">edit</i>
          </div>
        </div>
        <div class="empty-state" *ngIf="this.B2BPartner?.ShippingAddresses?.length == 0 && !ShowNewShippingAddressForm">
          <i class="material-icons">location_off</i>
          <p>{{'NoShippingAddresses' | translate}}</p>
        </div>
        <button class="save-personal-info-button" style="margin-bottom: 16px;" *ngIf="!EditingShippingAddress && !ShowNewShippingAddressForm" (click)="OpenNewShippingAddressForm();">
          <i class="material-icons">add</i>
          <span>{{'AddNewAddress' | translate}}</span>
        </button>
        <div *ngIf="EditingShippingAddress">
          <div class="subsection-header"><i class="material-icons">edit_location</i><span>{{'EditAddress' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ContactPerson' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.ContactPerson"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ContactCompany' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.ContactCompany"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'City' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.City"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'AddressLine' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.AddressLine"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ZipCode' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.ZipCode"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Phone' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.Phone"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Email' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingShippingAddress.Email"></div>
          <div class="self-service-form-actions">
            <button class="save-personal-info-button" (click)="SaveEditingShippingAddress();"><i class="material-icons">save</i><span>{{'SaveButton' | translate}}</span></button>
            <button class="save-personal-info-button cancel-btn" (click)="CancelEditShippingAddress();"><i class="material-icons">close</i><span>{{'CancelButton' | translate}}</span></button>
          </div>
        </div>
        <div *ngIf="ShowNewShippingAddressForm">
          <div class="subsection-header"><i class="material-icons">add_location</i><span>{{'AddNewAddress' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ContactPerson' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.ContactPerson"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ContactCompany' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.ContactCompany"></div>
          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{'Country' | translate}}</label>
            <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
              <div class="SendEmailOverlayTransparent" *ngIf="showNewShippingCountryDropdown" (click)="showNewShippingCountryDropdown = false"></div>
              <div class="SendEmailSearchBar" (click)="showNewShippingCountryDropdown = !showNewShippingCountryDropdown;">
                <i class="material-icons send-email-icon" style="color: #4a7bb8;">flag</i>
                <input type="text" class="SendEmailSearchInput" [value]="NewShippingAddress?.Country?.Name || ''" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="SendEmailSearchResults" *ngIf="showNewShippingCountryDropdown" style="max-height: 200px;">
                <div class="SendEmailSearchResult" *ngFor="let c of Countries" (click)="NewShippingAddress.Country = c; showNewShippingCountryDropdown = false;">
                  <div class="SendEmailResultMain"><span class="SendEmailResultLabel">{{ c.Name }}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'City' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.City"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'AddressLine' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.AddressLine"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'ZipCode' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.ZipCode" (blur)="CheckZipCodeDuplicate();"></div>
          <div class="self-service-warning" *ngIf="ShowZipCodeWarning"><i class="material-icons">warning</i><span>{{'ZipCodeAlreadyExists' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Phone' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.Phone"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Email' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewShippingAddress.Email"></div>
          <div class="self-service-form-actions">
            <button class="save-personal-info-button" (click)="SaveNewShippingAddress();"><i class="material-icons">save</i><span>{{'SaveButton' | translate}}</span></button>
            <button class="save-personal-info-button cancel-btn" (click)="ShowNewShippingAddressForm = false;"><i class="material-icons">close</i><span>{{'CancelButton' | translate}}</span></button>
          </div>
        </div>
      </div>

      <!-- ========== TAB 3: AGENTS ========== -->
      <div *ngIf="SelfServiceTab == 3">
        <div class="self-service-list" *ngIf="PartnerAgents?.length > 0 && !EditingAgent && !ShowNewAgentForm">
          <div class="self-service-list-item" *ngFor="let a of PartnerAgents" (click)="EditAgent(a);">
            <div class="self-service-list-item-main">
              <i class="material-icons" style="color: #007aff;">person</i>
              <div class="self-service-list-item-text">
                <span class="self-service-list-item-title">{{ a.Name }}
                  <span class="ProfilePhasesBadge" *ngIf="a.OrderPhases?.length > 0">{{a.OrderPhases.length}}</span>
                </span>
                <span class="self-service-list-item-sub">{{ a.Email }} · {{ a.Department?.Name }}</span>
              </div>
            </div>
            <i class="material-icons self-service-list-item-action">edit</i>
          </div>
        </div>
        <div class="empty-state" *ngIf="PartnerAgents?.length == 0 && !ShowNewAgentForm && !EditingAgent">
          <i class="material-icons">person_off</i>
          <p>{{'NoAgentsFound' | translate}}</p>
        </div>
        <button class="save-personal-info-button" style="margin-bottom: 16px;" *ngIf="!EditingAgent && !ShowNewAgentForm" (click)="OpenNewAgentForm();">
          <i class="material-icons">person_add</i>
          <span>{{'AddNewAgent' | translate}}</span>
        </button>
        <div *ngIf="EditingAgent">
          <div class="subsection-header"><i class="material-icons">edit</i><span>{{'EditAgent' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Name' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingAgent.Name"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Email' | translate}}</label><input type="email" class="ModernFormInput" [(ngModel)]="EditingAgent.Email"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Phone' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="EditingAgent.Phone"></div>
          <div class="ModernFormGroup" *ngIf="Departments?.length > 0">
            <label class="ModernFormLabel">{{'Department' | translate}}</label>
            <div class="SendEmailSearchContainer dropdown-upward" (click)="$event.stopPropagation()">
              <div class="SendEmailOverlayTransparent" *ngIf="showNewAgentDepartmentDropdown" (click)="showNewAgentDepartmentDropdown = false"></div>
              <div class="SendEmailSearchBar" (click)="showNewAgentDepartmentDropdown = !showNewAgentDepartmentDropdown;">
                <i class="material-icons send-email-icon" style="color: #4a7bb8;">badge</i>
                <input type="text" class="SendEmailSearchInput" [value]="EditingAgent?.Department?.Name || ''" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_up</i>
              </div>
              <div class="SendEmailSearchResults" *ngIf="showNewAgentDepartmentDropdown">
                <div class="SendEmailSearchResult" *ngFor="let d of Departments" (click)="EditingAgent.Department = d; showNewAgentDepartmentDropdown = false;">
                  <div class="SendEmailResultMain"><span class="SendEmailResultLabel">{{ d.Name }}</span></div>
                </div>
              </div>
            </div>
          </div>
          <!-- Select Notification Phases Button -->
          <div class="ModernFormGroup" *ngIf="EditingAgent?.ID > 0" style="margin-top:12px;">
            <button class="DefaultPhasesBtn" (click)="openDefaultPhasesPopup();"
                    [class.has-phases]="EditingAgent?.OrderPhases?.length > 0">
              <i class="material-icons">tune</i>
              <span>{{ 'SelectNotificationPhases' | translate }}</span>
              <span class="DefaultPhasesBtnCount" *ngIf="EditingAgent?.OrderPhases?.length > 0">{{EditingAgent.OrderPhases.length}}</span>
              <i class="material-icons" style="margin-left:auto;font-size:18px;color:#999;">expand_more</i>
            </button>
          </div>
          <div class="self-service-form-actions">
            <button class="save-personal-info-button" (click)="SaveEditingAgent();"><i class="material-icons">save</i><span>{{'SaveButton' | translate}}</span></button>
            <button class="save-personal-info-button cancel-btn" (click)="CancelEditAgent();"><i class="material-icons">close</i><span>{{'CancelButton' | translate}}</span></button>
            <button class="save-personal-info-button delete-btn" (click)="DeleteAgent(EditingAgent.ID);"><i class="material-icons">delete</i><span>{{'DeleteButton' | translate}}</span></button>
          </div>
        </div>
        <div *ngIf="ShowNewAgentForm">
          <div class="subsection-header"><i class="material-icons">person_add</i><span>{{'AddNewAgent' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Name' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewAgent.Name"></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Email' | translate}}</label><input type="email" class="ModernFormInput" [(ngModel)]="NewAgent.Email" (blur)="CheckAgentEmailDuplicate();"></div>
          <div class="self-service-warning" *ngIf="ShowAgentEmailWarning"><i class="material-icons">warning</i><span>{{'AgentEmailAlreadyExists' | translate}}</span></div>
          <div class="ModernFormGroup"><label class="ModernFormLabel">{{'Phone' | translate}}</label><input type="text" class="ModernFormInput" [(ngModel)]="NewAgent.Phone"></div>
          <div class="ModernFormGroup" *ngIf="Departments?.length > 0">
            <label class="ModernFormLabel">{{'Department' | translate}}</label>
            <div class="SendEmailSearchContainer dropdown-upward" (click)="$event.stopPropagation()">
              <div class="SendEmailOverlayTransparent" *ngIf="showNewAgentDepartmentDropdown" (click)="showNewAgentDepartmentDropdown = false"></div>
              <div class="SendEmailSearchBar" (click)="showNewAgentDepartmentDropdown = !showNewAgentDepartmentDropdown;">
                <i class="material-icons send-email-icon" style="color: #4a7bb8;">badge</i>
                <input type="text" class="SendEmailSearchInput" [value]="NewAgent?.Department?.Name || ''" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_up</i>
              </div>
              <div class="SendEmailSearchResults" *ngIf="showNewAgentDepartmentDropdown">
                <div class="SendEmailSearchResult" *ngFor="let d of Departments" (click)="NewAgent.Department = d; showNewAgentDepartmentDropdown = false;">
                  <div class="SendEmailResultMain"><span class="SendEmailResultLabel">{{ d.Name }}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="self-service-form-actions">
            <button class="save-personal-info-button" (click)="SaveNewAgent();"><i class="material-icons">save</i><span>{{'SaveButton' | translate}}</span></button>
            <button class="save-personal-info-button cancel-btn" (click)="ShowNewAgentForm = false;"><i class="material-icons">close</i><span>{{'CancelButton' | translate}}</span></button>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- Security Container -->
<div class="profile-container">
  <div class="profile-card security-card">
    <div class="card-header">
      <i class="material-icons">lock</i>
      <h2>{{'AccountSettingsPage.Security' | translate}}</h2>
    </div>

    <div class="card-content">
      <div class="security-fields">
        <!-- Old Password -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'AccountSettingsPage.OldPassword' | translate}}</label>
          <div class="ModernFormInputWithIcon">
            <input [type]="hide ? 'password' : 'text'" class="ModernFormInput" [(ngModel)]="this.Password">
            <i class="material-icons input-icon clickable" (click)="hide = !hide">
              {{hide ? 'visibility_off' : 'visibility'}}
            </i>
          </div>
        </div>

        <!-- New Password -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'AccountSettingsPage.NewPassword' | translate}}</label>
          <div class="ModernFormInputWithIcon">
            <input [type]="hideNewPass ? 'password' : 'text'" class="ModernFormInput" [(ngModel)]="this.NewPassword">
            <i class="material-icons input-icon clickable" (click)="hideNewPass = !hideNewPass">
              {{hideNewPass ? 'visibility_off' : 'visibility'}}
            </i>
          </div>
        </div>

        <!-- Confirm New Password -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'AccountSettingsPage.ConfirmNewPassword' | translate}}</label>
          <div class="ModernFormInputWithIcon">
            <input [type]="hideConfirmNewPass ? 'password' : 'text'" class="ModernFormInput" [(ngModel)]="this.ConfirmNewPassword">
            <i class="material-icons input-icon clickable" (click)="hideConfirmNewPass = !hideConfirmNewPass">
              {{hideConfirmNewPass ? 'visibility_off' : 'visibility'}}
            </i>
          </div>
        </div>
      </div>

      <!-- Change Password Button -->
      <button class="GridCommandButton GridCommandButtonBlue change-password-button" (click)="ChangeUserPassword();">
        <i class="material-icons">vpn_key</i>
        <span>{{'AccountSettingsPage.ChangePassword' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- API Credentials Container -->
<div class="profile-container" *ngIf="this.parent.User?.B2BSettings?.B2BSearchPriceAPIAccess == true">
  <div class="profile-card api-card">
    <div class="card-header api-header">
      <i class="material-icons">api</i>
      <h2>{{'YourAPICredentials' | translate}}</h2>
    </div>

    <div class="card-content">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'APIKey' | translate}}</label>
        <div class="ModernFormInputWithIcon">
          <textarea class="ModernTextarea readonly" rows="3" [(ngModel)]="this.parent.User.Id" readonly (click)="selectText($event)"></textarea>
          <i class="material-icons input-icon readonly">key</i>
        </div>
      </div>

      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'SecretToken' | translate}}</label>
        <div class="ModernFormInputWithIcon">
          <textarea class="ModernTextarea readonly" rows="3" [(ngModel)]="this.B2BPartner.ID" readonly (click)="selectText($event)"></textarea>
          <i class="material-icons input-icon readonly">key</i>
        </div>
      </div>

      <div class="api-badge" matTooltip="{{'B2BSearchPriceAPIAccessDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
        <i class="material-icons">verified</i>
        <span>{{'YouHaveAPIAccessFor' | translate}}: {{'B2BSearchPriceAPIAccess' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<!-- Default Agent Phases Popup -->
<div class="ProfilePhasesPopupOverlay" *ngIf="showDefaultPhasesPopup" (click)="closeDefaultPhasesPopup();">
  <div class="ProfilePhasesPopup" (click)="$event.stopPropagation();">
    <div class="ProfilePhasesPopupHeader">
      <div class="ProfilePhasesPopupTitle">
        <i class="material-icons">tune</i>
        {{ 'SelectNotificationPhases' | translate }} — {{selectedDefaultPhaseAgent?.Name}}
      </div>
      <button class="ProfilePhasesPopupClose" (click)="closeDefaultPhasesPopup();">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ProfilePhasesPopupBody">
      <p class="ProfilePhasesExplanation">
        <i class="material-icons" style="font-size:14px;vertical-align:middle;margin-right:4px;color:#4a7bb8;">info_outline</i>
        {{ 'NotificationPhasesExplanation' | translate }}
      </p>
      <div class="DefaultPhaseItem" *ngFor="let phase of defaultPhasesMasterData"
           [class.selected]="isDefaultPhaseSelected(phase)"
           (click)="toggleDefaultPhase(phase)">
        <div class="DefaultPhaseItemRow">
          <i class="material-icons DefaultPhaseCheckIcon"
             [style.color]="isDefaultPhaseSelected(phase) ? '#007aff' : '#ccc'">
            {{ isDefaultPhaseSelected(phase) ? 'check_circle' : 'radio_button_unchecked' }}
          </i>
          <span class="DefaultPhaseName">{{phase.Name}}</span>
        </div>
        <p class="DefaultPhaseDescription">{{phase.Description}}</p>
      </div>
    </div>
    <div class="ProfilePhasesPopupFooter">
      <button class="ProfilePhasesSaveBtn" (click)="saveDefaultPhases();" [disabled]="savingDefaultPhases">
        <i class="material-icons">save</i>
        {{'SaveButton' | translate}}
      </button>
    </div>
  </div>
</div>